export default {
  SUPPORT_SIGNED_MEDIA_URL: false,
  API_BASE_URL: "https://sg-gold-api-production.up.railway.app/api/v1",
  // http://localhost:3300/api/v1
  // https://api.sggold.co.in/api/v1
  // https://prod-jms-api-95f0a62de102.herokuapp.com/api/v1
};
